{
  "nav": {
    "pricing": "Цени",
    "contact": "Контакт",
    "menu": "Меню",
    "login": "Вход",
    "features": "Функции",
    "brandHomeAria": "Done-it — начало",
    "market": {
      "belgium": "Белгия",
      "international": "По света"
    }
  },
  "footer": {
    "tagline": "Done-it — Лесно отчитане на работното време.",
    "terms": "Условия",
    "privacy": "Поверителност",
    "contact": "Контакт"
  },
  "help": "Нужна ли ви е помощ?",
  "continue": "Продължи",
  "back": "Назад",
  "change": "Промени",
  "retry": "Опитай отново",
  "errors": {
    "unexpected": "Неочаквана грешка"
  },
  "step": {
    "of": "Стъпка {{n}} от {{total}}"
  },
  "funnel": {
    "title": "Абонамент · Done-it"
  }
}
